<template>
  <div class="endpoint_head">
    <h2>Get staff</h2>

    <div class="route">
      <i
        @click="
          $router.push('/documentation/api/staff#get');
          $toast.info('Set URL to endpoint');
        "
        :style="{ color: 'var(--clr-secondary)', cursor: 'pointer' }"
        class="fas fa-hashtag"
      ></i>
      <p class="tag tag-blue">GET</p>
      <p class="url">
        {{ apiUrl }}<span>/salons/:salonId/staff/:staffId</span>
      </p>
    </div>

    <div class="description">
      <p>Get a staff by staffId</p>
    </div>
  </div>

  <div class="endpoint_body">
    <div class="request">
      <h3>Request</h3>

      <!-- Path params -->
      <div class="endpoint_body_section path">
        <div class="head">
          <h4>Path Parameters</h4>
        </div>

        <ul>
          <li>
            <div class="col value">
              <p class="bold">salonId</p>
              <p class="description">ID of salon to add staff to</p>
              <p class="examples">
                Examples: <span>5f8a1d9b-3b0b-4c9a-9c0d-1a2b3c4d5e6f</span>
              </p>
            </div>

            <div class="col">
              <p class="required">required</p>
            </div>
          </li>

          <li>
            <div class="col value">
              <p class="bold">staffId</p>
              <p class="description">
                ID of staff to get (Note this is the "_id" and NOT the
                "staffId")
              </p>
              <p class="examples">
                Examples: <span>5f8a1d9b-3b0b-4c9a-9c0d-1a2b3c4d5e6d</span>
              </p>
            </div>

            <div class="col">
              <p class="required">required</p>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="response">
      <h3>Response</h3>

      <!-- Body -->
      <div class="endpoint_body_section path">
        <div class="head">
          <h4>Body</h4>
        </div>

        <ul>
          <li>
            <div class="col value">
              <p class="bold">staff</p>
              <p class="examples">
                Examples:
                <span
                  >{ "staffId": "64ac50907967f3a5c72e8a22", "firstName": "John",
                  "lastName": "Doe", "email": "john@doe.com", "accountCode":
                  "555666", "phoneNumber": "2175551234", "groups": [],
                  "onBooking": false, "onCalendar": false, "commission": 60,
                  "trackHourly": false, "hourlyRate": 0, "splitCheck": 100,
                  "splitOther": 0, "dailyFee": 0, "role": "low", "working":
                  false, "available": false, "schedule": { "default": [ { "day":
                  0, "blocks": [], "_id": "64ac50907967f3a5c72e8a27" }, { "day":
                  1, "blocks": [ { "start": "09:00", "end": "17:00", "_id":
                  "64ac50907967f3a5c72e8a29" } ], "_id":
                  "64ac50907967f3a5c72e8a28" }, { "day": 2, "blocks": [ {
                  "start": "09:00", "end": "17:00", "_id":
                  "64ac50907967f3a5c72e8a2b" } ], "_id":
                  "64ac50907967f3a5c72e8a2a" }, { "day": 3, "blocks": [ {
                  "start": "09:00", "end": "17:00", "_id":
                  "64ac50907967f3a5c72e8a2d" } ], "_id":
                  "64ac50907967f3a5c72e8a2c" }, { "day": 4, "blocks": [ {
                  "start": "09:00", "end": "17:00", "_id":
                  "64ac50907967f3a5c72e8a2f" } ], "_id":
                  "64ac50907967f3a5c72e8a2e" }, { "day": 5, "blocks": [ {
                  "start": "09:00", "end": "17:00", "_id":
                  "64ac50907967f3a5c72e8a31" } ], "_id":
                  "64ac50907967f3a5c72e8a30" }, { "day": 6, "blocks": [], "_id":
                  "64ac50907967f3a5c72e8a32" } ], "exceptions": [], "_id":
                  "64ac50907967f3a5c72e8a26" }, "services": [],
                  "defaultServiceLevel": 1, "additionalTurns": 0, "allowsEdits":
                  false, "isDeleted": false, "exemptFromServiceFees": false,
                  "_id": "64ac50907967f3a5c72e8a25", "customCommissions": [],
                  "customServiceLevels": [], "additionalTurnsLogs": [] }</span
                >
              </p>
            </div>

            <div class="col">
              <p class="required">required</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    apiUrl() {
      return process.env.VUE_APP_RASERVA_BACKEND;
    },
  },
};
</script>

<style lang="scss" scoped>
.endpoint {
  .tag {
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 700;
    padding: 8px;
    border-radius: 5px;
    color: white;

    &-blue {
      background-color: var(--clr-secondary);
    }
  }

  &_head {
    h2 {
      font-size: 36px;
      margin-bottom: 16px;
    }

    .route {
      padding: 8px 16px;
      border-radius: 5px;
      background-color: var(--clr-white-2);
      display: flex;
      align-items: center;
      gap: 16px;

      .url {
        color: var(--clr-gray);

        span {
          color: var(--clr-primary);
          font-weight: 700;
        }
      }
    }

    .description {
      margin-top: 32px;
    }
  }

  &_body {
    .request,
    .response,
    .reqResExamples {
      margin-top: 32px;
      padding: 16px;
      border-radius: 5px;
      border: 1px solid var(--clr-light);
    }

    h3 {
      font-size: 24px;
      margin-bottom: 32px;
    }

    &_section {
      &:not(:first-child) {
        margin-top: 32px;
      }

      .head {
        display: flex;
        justify-content: space-between;

        h4 {
          font-size: 20px;
          margin-bottom: 16px;
          color: var(--clr-secondary);
        }

        p {
          font-size: 14px;
          color: var(--clr-gray);
        }
      }

      ul {
        .subitem {
          margin-left: 32px;
        }

        li {
          display: flex;
          justify-content: space-between;
          font-size: 14px;

          &:not(:first-child) {
            margin-top: 16px;
          }

          .value {
            display: flex;
            flex-direction: column;
            gap: 4px;
          }

          .bold {
            font-weight: 700;
          }
          .required {
            color: orangered;
          }

          .description {
            margin: 4px 0;
            color: var(--clr-gray);
          }

          .examples {
            span {
              background-color: var(--clr-white-2);
              padding: 4px 8px;
              border-radius: 5px;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
